import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    drawingsHistory: {},
    loading: false,
    error: null,
    pagination: {
        currentPage: 1,
        perPage: 10,
        totalPage: 0,
        totalData: 0
    }
};

const drawingsHistorySlice = createSlice({
    name: "DrawingsHistory",
    initialState,
    reducers: {
        setLoading(state, action) {
            state.loading = action.payload;
        },
        setDrawingsHistory(state, action) {
            state.drawingsHistory = action.payload.data || {};
            state.pagination = {
                currentPage: action.payload.currentPage || 1,
                perPage: action.payload.perPage || 10,
                totalPage: action.payload.totalPage || 0,
                totalData: action.payload.totalData || 0
            };
        },
        setError(state, action) {
            state.error = action.payload;
        },
    },
});

export const {
    setLoading,
    setDrawingsHistory,
    setError,
} = drawingsHistorySlice.actions;

export default drawingsHistorySlice.reducer;
